var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.641,
    height: 9.168,
    viewBox: "0 0 15.641 9.168",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.035,11.129l4.584-4.584L83.035,1.962,82.011,2.976,84.84,5.8H71.979V7.286H84.84l-2.829,2.819Z",
    transform: "translate(87.619 11.129) rotate(180)",
    fill: "#a4abb7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkArrow);
export default __webpack_public_path__ + "static/media/dark-arrow.7fb59259fb18faa1c653633b434ce7d6.svg";
export { ForwardRef as ReactComponent };